import { provideAuthInitializer } from '@yoshu-lib/core/auth/auth-initializer.factory'
import { providePageTitle } from '@yoshu-lib/core/page-title/page-title.binder'

import { provideCotyAuthService } from './config/auth-service.provider'
import { provideCotyAuthStore } from './config/auth-store.provider'
import { provideEnvironment } from './config/environment.provider'

export const provideCore = () => [
  provideEnvironment(),
  provideAuthInitializer(),
  providePageTitle(),
  provideCotyAuthService(),
  provideCotyAuthStore()
]
